export default {
  primaryColor: '#75FE00',
  transparent: 'rgba(255,255,255,0)',
  redText: '#FF0000',
  redError: '#B81F1E',
  black: '#000000',
  white: '#ffffff',
  amm: '#67E100',
  chartGray: '#D6D6D6',
  ammChartDot: '#67E100',
  alcoholChartBar: '#75FE00',
  gachaGoodLuck: '#005BBF',
}
